import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-salary-type-lang',
  templateUrl: './salary-type-lang.component.html',
  styleUrls: ['./salary-type-lang.component.css']
})
export class SalaryTypeLangComponent implements OnInit {
    salaryTypeId;

    public inputListLanguages: LanguageItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.salaryTypeId = this.stateService.getStateParams()['salarytype_id'];
    }

    private async loadLanguages() {
        if (!!this.salaryTypeId) {
            this.inputListLanguages = await this.datatask.Post(485, { salarytype_id: this.salaryTypeId });
        }
    }

    public async saveChanges() {
        if (!!this.inputListLanguages) {
            try {
                this.saving = true;

                await this.datatask.Post(486, { records: this.inputListLanguages });

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadLanguages();
    }

    ngOnInit() {
        this.init();
    }
}

interface LanguageItem {
    salarytype_id: number;
    salarytype_lang_name: string;
    language_id: string;
    language_name: string;
    orderby: number;
}
